import busConnects from './js/core/index.js';

/**
 * Declare On DOM Content Loaded
 */
let onDomLoaded = () => {
    console.log('DOM Content Loaded');
    
    // Always initialize MenuToggle
    new busConnects.Controls.MenuToggle;

    // Initialize GalleryModal if we have a gallery modal on the page
    if (document.getElementById('galleryModal')) {
        new busConnects.Controls.GalleryModal;
    }

    // Initialize Carousel and CarouselModal only if we have carousel elements
    if (document.querySelector('.swiper') || document.getElementById('videoModal')) {
        new busConnects.Controls.Carousel;
        new busConnects.Controls.CarouselModal;
    }

    onReload();
};

/**
 * Declare onReload function
 * All functions inside are used for any reload events to reinitialise;
 */
let onReload = () => {
};
 
/**
 * Declare On Window.Load
 */
let onWinLoad = () => {
};
 
/**
 * Declare On Window.Load
 */
let onWinResize = () => { };

// Only attach the event listener once and prevent multiple initializations
let initialized = false;

function init() {
    if (!initialized) {
        initialized = true;
        onDomLoaded();
    }
}

// Choose either DOMContentLoaded or immediate execution
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

/**
 * Execute DOMContent & OnWindowLoad
 */
window.addEventListener('resize', onWinResize);
window.addEventListener('change', onReload);

/**
 * Export Default
 */
export default {};